export default "__VITE_ASSET__DZf64dXd__"